import React from 'react'
import styled from 'styled-components'
import ImageLibrary from '../../image_library/ImageLibrary'

const S = {
    Body: styled.div`
        width: 100%;
        padding: 0 20px;
    `,
}

const ImageGallery = () => (
    <S.Body>
        <ImageLibrary />
    </S.Body>
)

export default ImageGallery
